import { axiosAuthFetch } from "../../helpers/axios";
import { fetchAllPages } from "../../helpers/pagination";
import { API_BASE_URL, API_GRAPHQL } from "../../constants";

const PAGE_SIZE = 100;

// Henter ALLE uleste notifikasjoner for brukeren. Uten paginering returnerer
// Strapi GraphQL bare de 10 første, så når de ble fjernet dukket de 10 neste
// opp etter refresh og det så ut som de fjernede kom tilbake.
export async function GetNotifications(id) {
    const all = await fetchAllPages(async (page) => {
        const query =`
            query{
                notifications(
                    filters: {
                        receiver: {id: {eq:${id}}}
                        isRead: {eq: false}
                    }
                    sort: "id:asc"
                    pagination: {page: ${page}, pageSize: ${PAGE_SIZE}}
                ) {
                    meta{
                        pagination{
                            pageCount
                            total
                        }
                    }
                    data{
                        id
                        attributes{
                            message
                            event
                            workout_session{
                                data{
                                    id
                                }
                            }
                            check_in{
                                data{
                                    id
                                }
                            }
                        }
                    }
                }
            }
        `;

        const response = await axiosAuthFetch(API_GRAPHQL, { query }, 'post');

        // GraphQL svarer 200 også ved feil – ikke la det se ut som en tom liste
        if (response?.errors?.length || !response?.data?.notifications) {
            throw new Error(response?.errors?.[0]?.message || 'Kunne ikke hente notifikasjoner');
        }

        const result = response.data.notifications;
        return { data: result.data, pagination: result.meta?.pagination };
    });

    return { notifications: { data: all } };
}

// "Fjern" i UI-et = sett isRead til true. Kaster hvis Strapi ikke bekrefter
// at akkurat denne notifikasjonen nå er lest – et 200-svar alene er ikke nok –
// slik at den ikke fjernes fra lista uten å være lagret.
export async function MarkNotificationAsRead(notifId) {
    const response = await axiosAuthFetch(`${API_BASE_URL}/notifications/${notifId}`, {
        data: {
            isRead: true,
        },
    }, 'PUT');

    const updated = response?.data;
    if (String(updated?.id) !== String(notifId) || updated?.attributes?.isRead !== true) {
        throw new Error(`Notifikasjon ${notifId} ble ikke bekreftet som lest`);
    }

    return response;
}
